export const useAppState = () => {

    const isLoading = useState( 'isLoading', () => true );
    const hasError = useState( 'hasError', () => false );

    const stopLoading = () => {
        isLoading.value = false;
        document.body.style.overflow = 'auto';
    };

    const startLoading = () => {
        isLoading.value = true;
        document.body.style.overflow = 'hidden';
    };

    const triggerError = () => {
        hasError.value = true;
        stopLoading();
    };

    return { isLoading, hasError, startLoading, stopLoading, triggerError };

};
